const LinkControlType = "makeswift::controls::link";
function Link(config = {}) {
  return { type: LinkControlType, config };
}
function copyLinkData(value, context) {
  if (value == null)
    return value;
  if (value.type === "OPEN_PAGE") {
    const pageId = value.payload.pageId;
    if (pageId != null) {
      return {
        ...value,
        payload: {
          ...value.payload,
          pageId: context.replacementContext.pageIds.get(pageId) ?? pageId
        }
      };
    }
  }
  return value;
}
export {
  Link,
  LinkControlType,
  copyLinkData
};
//# sourceMappingURL=link.js.map